import React, { useState, useEffect, useContext } from 'react'
import { useParams, useHistory, Link } from 'react-router-dom'
import { Container } from 'react-bootstrap'
import LoadingOverlay from 'react-loading-overlay'
import { PropagateLoader } from 'react-spinners'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'

import { ModuleContext } from '../../contexts/ModuleContext'
import { moduleContent } from '../../Module.config'
import * as LRS from '../../api/api'

import { FullFaultAttempt } from '../../Types'

import NavigationBar from '../NavigationBar'
import { FaultAttemptDetails } from './FaultAttemptDetails'

import { SimutechOrange } from '../../styles/Theme'
import { SecondaryButton, ButtonGroup, PrimaryButton } from '../../styles/Buttons'
import { TroubleshootActionType, useTroubleshoot } from '../../contexts/TroubleshootContext'

const FaultAttempt: React.FC = () => {

    const { dispatch } = useTroubleshoot()
    const context = useContext(ModuleContext)

    const [error, setError] = useState('')

    const [faultAttempt, setFaultAttempt] = useState<FullFaultAttempt>({} as FullFaultAttempt)
    const { id } = useParams()
    const history = useHistory()

    useEffect(() => {
        if (!context.user.userId || faultAttempt._id) return
        const fetchData = async () => {
            const faultAttemptDetails: FullFaultAttempt[] = await LRS.getFaultAttemptDetails(id, context.user.companyId)
            if (!faultAttemptDetails[0]) throw new Error('Invalid fault attempt')
            setFaultAttempt(faultAttemptDetails[0])
        }
        fetchData()
            .catch(error => setError(error.toString()))
    }, [context.user.companyId, context.user.userId, faultAttempt._id, id])

    const goToFaultHistory = (e: MouseEvent) => {
        e.preventDefault()
        history.push('/faulthistory')
    }

    const saveFaultId = (faultId: string) => {
        context.faultID = faultId //TODO: This is bad, but the faultID in ModuleContext is still needed in Simulation and UnityComponent until they are converted to React.FC with hooks.        
        dispatch({ type: TroubleshootActionType.SAVE_FAULT_ID, payload: faultId })
    }

    const handleRetry = (e: MouseEvent) => {
        e.preventDefault()
        saveFaultId(faultAttempt.faultId)
        history.push('/workorder')
    }
    const TopBar = () => <NavigationBar pageTitle={moduleContent.title} />

    if (error) return (
        <>
            <TopBar />
            <Wrapper>

                <ErrorMessage className="alert alert-danger text-center">
                    <h2>
                        <FontAwesomeIcon icon={faExclamationTriangle} />&nbsp;&nbsp;
                        {error}
                    </h2>
                    <p><Link to={'/faulthistory'}>{'Go Back'}</Link></p>

                </ErrorMessage>
            </Wrapper>
        </>
    )
    if (!context.user.userId || !faultAttempt._id) {
        const msg = !context.user.userId ? 'Loading your account' : 'Loading fault attempt details'
        return (
            <div className="body-override">
                <TopBar />
                <Container className="pre-fault" fluid={true}>
                    <LoadingOverlay
                        active={!faultAttempt._id}
                        spinner={<PropagateLoader color={SimutechOrange} />}
                        classNamePrefix='loader-'
                        text={msg}
                    />
                </Container>
            </div>
        )
    }

    return (
        <div className="body-override">
            <TopBar />
            <Wrapper>

                <FaultAttemptDetails {...faultAttempt} />

                <ButtonGroup>
                    <PrimaryButton onClick={goToFaultHistory}>
                        {'BACK'}
                    </PrimaryButton>
                    <SecondaryButton
                        disabled={!id}
                        onClick={handleRetry}
                    >
                        {'Retry Fault'}
                    </SecondaryButton>
                </ButtonGroup>
            </Wrapper>
        </div>
    )
}

export default FaultAttempt

const Wrapper = styled.div({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
    width: '100%',
    height: '100%',
    margin: 'auto',
    padding: '1em'
})

const ErrorMessage = styled.div({
    padding: '2em',
    maxWidth: '500px'

})